import Immutable from 'immutable';

const _initialState = Immutable.Map({
  visible: false,
  content: null,
});

function slideUpMenuShow(state, payload) {
  state.set('visible', true);
  state.set('content', payload.content);
}

function slideUpMenuHide(state) {
  state.set('visible', false);
}

export default function reducer(state = _initialState, action) {
  return state.withMutations((mutableState) => {
    return (
      {
        SLIDE_UP_MENU_SHOW: slideUpMenuShow,
        SLIDE_UP_MENU_HIDE: slideUpMenuHide,
      }[action.type] || ((s) => s)
    )(mutableState, action.payload);
  });
}
